import React from "react"
import PropTypes from "prop-types"
import { withTranslation } from "react-i18next"
import { Card, CardBody, CardHeader, Col, Row, Spinner } from "reactstrap"
import classNames from "classnames"
import PieChart from "components/Charts/PieChart"
import { useAPI } from "hooks/useAPI"
import { useIndicadoresFiltrosStore } from "store/useIndicadoresFiltrosStore"

const DistTransportadora = props => {
  const { bgColor, outline } = props

  const REPORT_ID = 15

  const fetchReports = useIndicadoresFiltrosStore(state => state.fetchReports)
  const filtrosSelecionados = useIndicadoresFiltrosStore(
    state => state.filtrosSelecionados
  )

  const { payload, error, isLoading } = useAPI(
    REPORT_ID,
    filtrosSelecionados,
    fetchReports
  )

  let dataLabels = []
  let dataValues = []

  payload?.pie?.data?.columns.map(el => {
    dataLabels.push(el[0])
    dataValues.push({ value: el[1], name: el[0] })
  })

  return (
    <Card
      className={classNames({
        "mini-stats-wid": true,
        border: outline,
      })}
      outline
      color={bgColor}
    >
      {payload?.pie?.data?.columns.length > 0 ? (
        <React.Fragment>
          <CardHeader tag={"h4"} className="bg-transparent border-bottom">
            {!isLoading && (
              <Row>
                <Col>{payload?.title}</Col>
              </Row>
            )}
            {isLoading && (
              <Row className="mb-2">
                <Col>
                  <span className="placeholder col-3"></span>
                </Col>
              </Row>
            )}
          </CardHeader>
          <CardBody>
            {!isLoading && (
              <PieChart
                colors={
                  '["--bs-primary","--bs-secondary", "--bs-danger","--bs-info", "--bs-success" ]'
                }
                dataLabels={dataLabels}
                dataValues={dataValues}
                name={payload?.title}
                radius="60%"
                centerX="50%"
                centerY="50%"
                height={"300px"}
              />
            )}
            {isLoading && (
              <div className="mt-3" style={{ textAlign: "center" }}>
                <Spinner
                  className="ms-2"
                  style={{ width: "4rem", height: "4rem" }}
                  color="primary"
                />
              </div>
            )}
          </CardBody>
        </React.Fragment>
      ) : (
        <React.Fragment>
          <CardHeader tag={"h4"} className="bg-transparent border-bottom">
            {!isLoading && (
              <Row>
                <Col>{payload?.title}</Col>
              </Row>
            )}
            {isLoading && (
              <Row className="mb-2">
                <Col>
                  <span className="placeholder col-3"></span>
                </Col>
              </Row>
            )}
          </CardHeader>
          <CardBody>
            {!isLoading && (
              <div style={{ textAlign: "center" }}>
                <h5>Nenhum dado foi encontrado.</h5>
              </div>
            )}
            {isLoading && (
              <div className="mt-3" style={{ textAlign: "center" }}>
                <Spinner
                  className="ms-2"
                  style={{ width: "4rem", height: "4rem" }}
                  color="primary"
                />
              </div>
            )}
          </CardBody>
        </React.Fragment>
      )}
    </Card>
  )
}

DistTransportadora.propTypes = {
  bgColor: PropTypes.string,
  outline: PropTypes.bool,
}

export default withTranslation()(DistTransportadora)
